import type { BrowserSessionStatus } from "@/platform/api/session-contract"
import { sessionKeys } from "@/platform/session/session-keys"
import { viewerOf } from "@/platform/session/viewer"

import type { QueryClient } from "@tanstack/react-query"

export const isProbeKey = (queryKey: readonly unknown[]): boolean => queryKey[0] === sessionKeys.probe[0] && queryKey[1] === sessionKeys.probe[1]

export const currentViewer = (queryClient: QueryClient): string | null => {
  const status = queryClient.getQueryData<BrowserSessionStatus>(sessionKeys.probe)
  return status ? viewerOf(status) : null
}
